import React from 'react';

export function CssQns() {
  const val1 = "https://www.w3schools.com/css/css_quiz.asp";

  return (
    <div>
      <h1 className="html_qns_heading">
        These are the recommended Qns for CSS Testing links that you can refer with this Website
      </h1>

      <h4 className="des_qns_html">
        1. Dive Into The <strong>Main</strong> Page <br />
        2. Click Start with Quiz <br />
        3. Test Your knowledge and attempt for better clarification
      </h4>

      <div className="container_html_qns_links">
        <p className="vid" style={{ marginTop: '50px' }}>
          **** Practice For CSS (Quiz) ****
          <button
            style={{
              marginLeft: '200px',
              padding: '7px',
              background: 'black',
              color: 'white',
              borderRadius: '8px'
            }}
            onClick={() => window.open(val1, "_blank")}
          >
            Click Me
          </button>
        </p>
      </div>
    </div>
  );
}

export default CssQns;
